/**
 * Resolves the auth API base URL used for login, registration, and OAuth.
 * Used for auth enablement (Api) and OAuth redirect (AuthModal).
 * Returns null when auth is not configured or not resolvable (e.g. SSR without env).
 */
export function resolveAuthApiBaseUrl(configuredValue: string | undefined): string | null {
    if (typeof window === 'undefined') {
        return null;
    }

    const host = window.location.hostname.toLowerCase();
    const configured = (configuredValue || '').trim();

    const knownHostApiBase = (() => {
        if (host === 'staging.kromatic.com') {
            return 'https://staging-api.kromatic.com';
        }
        if (host === 'kromatic.com' || host === 'www.kromatic.com') {
            return 'https://api.kromatic.com';
        }
        return null;
    })();

    if (!configured) {
        return knownHostApiBase;
    }

    if (/^https?:\/\//i.test(configured)) {
        try {
            const parsed = new URL(configured);
            if (
                knownHostApiBase &&
                (parsed.hostname === 'staging.kromatic.com' ||
                    parsed.hostname === 'kromatic.com' ||
                    parsed.hostname === 'www.kromatic.com') &&
                parsed.pathname.startsWith('/api')
            ) {
                return knownHostApiBase;
            }
            return configured.replace(/\/+$/, '');
        } catch {
            return knownHostApiBase;
        }
    }

    if (configured.startsWith('/')) {
        if (knownHostApiBase) {
            return knownHostApiBase;
        }
        return `${window.location.origin}${configured}`.replace(/\/+$/, '');
    }

    return knownHostApiBase;
}
